import React from "react";
import { Header, Placeholder, Segment } from "semantic-ui-react";

const Loader = ({ message, linesCount = 5 }) => (
  <Segment size="large" padded="very" basic textAlign="center">
    <Header data-test="loader_message" content={message} />
    <Placeholder fluid>
      {Array(linesCount)
        .fill()
        .map((_, idx) => (
          <Placeholder.Line key={idx} />
        ))}
    </Placeholder>
  </Segment>
);

export default Loader;
